module.exports = __webpack_public_path__ + "img/world.0daad0be.svg";